import React from 'react';
import { cn } from './utils';

interface StatBoxProps {
  label: string;
  value: React.ReactNode;
  className?: string;
}

const StatBoxBase = function StatBox({ label, value, className }: StatBoxProps) {
  return (
    <div className={cn('p-3 md:p-4 rounded-lg bg-[#F0F0F0] border border-border', className)}>
      <p className="text-xs text-muted-foreground mb-1">{label}</p>
      <div className="text-lg md:text-xl font-semibold text-[#242424]">{value}</div>
    </div>
  );
};

export const StatBox = React.memo(StatBoxBase);

interface StatGridProps {
  columns?: 2 | 3 | 4;
  children: React.ReactNode;
  className?: string;
}

const COLUMN_CLASSES: Record<number, string> = {
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
  4: 'grid-cols-2 md:grid-cols-4',
};

export function StatGrid({ columns = 2, children, className }: StatGridProps) {
  return (
    <div className={cn('grid gap-3 md:gap-4', COLUMN_CLASSES[columns], className)}>
      {children}
    </div>
  );
}
